import React from 'react';
import ModernPageHeader from '../WorkListTable/components/ModernPageHeader';
import { HelpCircle } from 'lucide-react';

const Help = () => {
    const demoVideoUrl = process.env.DOCUMENT_VIDEO;
    const documentPdf = process.env.DOCUMENT_PDF;

    return (
        <div className="relative min-h-[70vh] w-full text-[1.05rem] leading-relaxed text-[var(--v2-text-primary)]">
            <ModernPageHeader
                title="Help Center"
                subtitle="Watch demos, read documentation, and learn about the platform"
                icon={<HelpCircle className="w-[15px] h-[15px]" />}
            />

            {/* Main Content */}
            <div className="relative flex flex-col items-center justify-center gap-6">
                <p className="text-center max-w-3xl text-[15px] text-[var(--v2-text-secondary)]">
                    Watch the demo video below or read{' '}
                    <a
                        href={documentPdf}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-[var(--v2-primary-600)] font-semibold hover:underline transition-colors"
                    >
                        documentation
                    </a>{' '}
                    to get started with our platform. If you have any questions, feel free to reach out to{' '}
                    <a href="/support" className="text-[var(--v2-primary-600)] font-semibold hover:underline transition-colors">
                        Support
                    </a>
                    .
                </p>

                {demoVideoUrl ? (
                    <div className="w-full max-w-3xl overflow-hidden rounded-xl border border-[var(--v2-border-card)] bg-[var(--v2-bg-card)] shadow-[var(--v2-shadow-card)]">
                        <video
                            className="w-full h-auto"
                            controls
                            crossOrigin="anonymous"
                        >
                            <source src={demoVideoUrl} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                ) : (
                    <div className="flex flex-col items-center text-center rounded-2xl border border-dashed border-[var(--v2-border-subtle)] bg-[var(--v2-bg-card)] p-12 shadow-[var(--v2-shadow-card)]">
                        <div className="w-20 h-20 rounded-2xl bg-[var(--v2-bg-surface)] flex items-center justify-center mb-4">
                            <svg className="w-10 h-10 text-[var(--v2-text-muted)]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                        </div>
                        <p className="text-lg font-semibold text-[var(--v2-text-primary)] mb-1">
                            No demo video available
                        </p>
                        <p className="text-[15px] text-[var(--v2-text-secondary)]">
                            Please check back later or contact support for assistance.
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Help;
